/**
 * Deliberate duplicate of `src/api/profiles/files.ts`. The only difference is the upload
 * endpoint.
 *
 * The two are kept as separate modules by decision D6 of the `move-event-images-to-content-api`
 * change: event images are owned by content-api (`POST /api/v1/events/images`) while profile
 * files stay on profiles-api (`POST /api/v1/profiles/files`). Sharing one module would have
 * meant editing a production Profiles screen used by four other forms, and we would not put
 * that inside an events change's blast radius.
 *
 * **If you change one, check the other.**
 */
import { fetchRaw } from "../client";

export { buildFilesUrl, FILES_BASE_URL } from "../filesUrl";
export type { ImageRef } from "../filesUrl";

export type FileUploadResult = {
  hash: string;
  filename: string;
  url: string;
};

export const eventFilesService = {
  async upload(file: File): Promise<FileUploadResult> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetchRaw("/v1/events/images", { method: "POST", body: formData });
    if (!response.ok) {
      let message = `Failed to upload file: HTTP ${response.status}`;
      try {
        const body = (await response.json()) as { error?: unknown };
        if (typeof body.error === "string") message = body.error;
      } catch {
        // keep default
      }
      throw new Error(message);
    }
    const raw = (await response.json()) as Record<string, unknown>;
    return {
      hash: String(raw.hash ?? ""),
      filename: String(raw.filename ?? file.name),
      url: String(raw.url ?? ""),
    };
  },
};
